import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, InputLabel, FormControl, Typography, Select, MenuItem, FormHelperText, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment'
import {getDateFormat} from "../../sc-utilities/date";
const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right",
        width: '100%'
    }
});

const TransportColliForm = props => {
    const { classes, formSettings, create, initialValues, loading, handleSubmit, translations, orders, groups } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, setFieldValue, handleChange, handleBlur, handleSubmit } = formikProps;

                    const inputProps = {
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                        },
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>

                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['name'] || 'Name'}
                                label={translations['name'] || 'Name'}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />

                            <TextField
                                name="Description"
                                value={values.Description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations['description'] || 'Description'}
                                label={translations['description'] || 'Description'}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />

                            <TextField
                                name="Location"
                                value={values.Location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Location && touched.Location)}
                                placeholder={translations['location'] || 'Location'}
                                label={translations['location'] || 'Location'}
                                margin={"dense"}
                                fullWidth={true}
                                inputProps={inputProps}
                            />

                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["order_text"] || "Please select order"}</InputLabel>
                                <Select
                                    name="Order"
                                    label={translations['order'] || 'Order'}
                                    margin={"dense"}
                                    value={!values.Order ? '' : values.Order}
                                    onChange={handleChange}
                                >
                                    {(orders ? [...orders] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormHelperText>{translations['select_arrived_at'] || 'Please select arrived date'}</FormHelperText>
                            <KeyboardDatePicker
                                clearable
                                name={'ArrivedDate'}
                                onBlur={handleBlur}
                                maxDate={moment()}
                                error={!!(errors.ArrivedDate && touched.ArrivedDate)}
                                onChange={(date) =>
                                    setFieldValue("ArrivedDate", date)
                                }
                                value={values.ArrivedDate !== "" ? values.ArrivedDate : null}
                                margin={"dense"}
                                onAccept={date => setFieldValue("ArrivedDate", date)}
                                fullWidth={true}
                                format={getDateFormat()}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["group"] || "Group"}</InputLabel>
                                <Select
                                    name="GroupID"
                                    label={translations["group"] || "Group"}
                                    margin={"dense"}
                                    value={values.GroupID}
                                    onChange={handleChange}
                                >
                                    {(groups ? [...groups] : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.displayValue}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <div className={classes.buttons}  >
                                {formSettings.ButtonCancel ? (
                                    <Button
                                        className={classes.cancel}
                                        variant="contained"
                                        fullWidth={true}
                                        color={formSettings.ButtonCancel.Color}
                                        onClick={formSettings.ButtonCancel.handleCancel}
                                        disabled={loading}
                                    >
                                        {formSettings.ButtonCancel.Title}
                                    </Button>
                                ) : null
                                }

                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        style={{ width: '100%' }}
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {!create ? loading ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title
                                            : isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(TransportColliForm);
